export const environment = {
  production: true,
  // TRESOR_PAY: 'pk_live_ZVmuUtknwrYiCpAFUiisfmNi',
  TRESOR_PAY: 'pk_live_aApRGlocX20m0pLxQ9GriSO1',
  API_CADASTRE: 'https://b-test-cadastre.andf.bj:9299',
  API_URL: 'https://b-test-citizen.andf.bj/citizen-portal/api/v1/',

  BaseUrls: 'https://b-test-engine.andf.bj/api/v1',
  PORTAL_API_URL: 'https://b-test-portal.andf.bj/procedure-d-enregistrement-collectif/v1',
  ENGINE_API_URL: 'https://b-test-engine.andf.bj/api/v1',
  // ENGINE_API_URL: 'http://192.168.100.120:8080/api/v1',
  URL_LINK:
    'https://pprodauth.service-public.bj/citizen/login?client_id=andf-efb&redirect_uri=https:%2F%2Ftest-citizen.andf.bj&scope=openid&response_type=code',
};
